<template>
  <div class="button-frame">
    <i
      class="imagebtn icon icon-image"
      @click="openPopUp"
    />
    <div v-show="visibility">
      <div class="overlay" @click.self="closePopUp"></div>
      <div class="pop-up">
        <img class="item-image" :src="imagePath"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopUpImage',
  props: {
    imagePath: {
      type: String,
      default: null,
    },
  },
  data() {
    return { visibility: false };
  },
  methods: {
    openPopUp() {
      this.visibility = true;
    },
    closePopUp() {
      this.visibility = false;
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  background-color: black;
  opacity: 0.5;
}
.pop-up {
  width: 80%;
  position: fixed;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: black;
}
.imagebtn {
  margin: 8px;
  top: -5px;
  position: relative;
  cursor: pointer;
}
.button-frame {
   user-select: none;
}
.item-image {
  width: 100%;
}
</style>